export * from './defaultLabelColors'
export * from './proccessLabelColor'